"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var connect_1 = require("@0x/connect");
var utils_1 = require("../utils");
var base_order_provider_1 = require("./base_order_provider");
exports.PER_PAGE_DEFAULT = 100;
var BaseSRAOrderProvider = /** @class */ (function (_super) {
    __extends(BaseSRAOrderProvider, _super);
    /**
     * This is an internal class for Websocket and Polling Order Providers
     */
    function BaseSRAOrderProvider(orderStore, httpEndpoint, perPage) {
        if (perPage === void 0) { perPage = exports.PER_PAGE_DEFAULT; }
        var _this = _super.call(this, orderStore) || this;
        _this._httpClient = new connect_1.HttpClient(httpEndpoint);
        _this._perPage = perPage;
        return _this;
    }
    /**
     * Returns the availale Asset pairs from the SRA endpoint. This response is direct from the endpoint
     * so this call blocks until the response arrives.
     */
    BaseSRAOrderProvider.prototype.getAvailableAssetDatasAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestOpts, recordsToReturn, hasMorePages, page, _a, total, records, perPage, lastPage;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOpts = {
                            perPage: this._perPage,
                        };
                        recordsToReturn = [];
                        hasMorePages = true;
                        page = 1;
                        _b.label = 1;
                    case 1:
                        if (!hasMorePages) return [3 /*break*/, 3];
                        return [4 /*yield*/, utils_1.utils.attemptAsync(function () {
                                return _this._httpClient.getAssetPairsAsync(requestOpts);
                            })];
                    case 2:
                        _a = _b.sent(), total = _a.total, records = _a.records, perPage = _a.perPage;
                        recordsToReturn = __spread(recordsToReturn, records);
                        page += 1;
                        lastPage = Math.ceil(total / perPage);
                        hasMorePages = page <= lastPage;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, recordsToReturn];
                }
            });
        });
    };
    /**
     * Submits the SignedOrder to the SRA endpoint
     * @param orders the set of signed orders to add
     */
    BaseSRAOrderProvider.prototype.addOrdersAsync = function (orders) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, accepted, rejected, orders_1, orders_1_1, order, e_2, e_1_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accepted = [];
                        rejected = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        orders_1 = __values(orders), orders_1_1 = orders_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!orders_1_1.done) return [3 /*break*/, 7];
                        order = orders_1_1.value;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._httpClient.submitOrderAsync(order)];
                    case 4:
                        _b.sent();
                        accepted.push(order);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        rejected.push({ order: order, message: e_2.message });
                        return [3 /*break*/, 6];
                    case 6:
                        orders_1_1 = orders_1.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (orders_1_1 && !orders_1_1.done && (_a = orders_1.return)) _a.call(orders_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/, { accepted: accepted, rejected: rejected }];
                }
            });
        });
    };
    BaseSRAOrderProvider.prototype._fetchLatestOrdersAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, latestSellOrders, latestBuyOrders;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this._getAllPaginatedOrdersAsync(makerAssetData, takerAssetData),
                            this._getAllPaginatedOrdersAsync(takerAssetData, makerAssetData),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), latestSellOrders = _a[0], latestBuyOrders = _a[1];
                        return [2 /*return*/, __spread(latestSellOrders, latestBuyOrders)];
                }
            });
        });
    };
    BaseSRAOrderProvider.prototype._getAllPaginatedOrdersAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var recordsToReturn, requestOpts, hasMorePages, page, _a, total, records, perPage, lastPage;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        recordsToReturn = [];
                        requestOpts = {
                            makerAssetData: makerAssetData,
                            takerAssetData: takerAssetData,
                            perPage: this._perPage,
                        };
                        hasMorePages = true;
                        page = 1;
                        _b.label = 1;
                    case 1:
                        if (!hasMorePages) return [3 /*break*/, 3];
                        return [4 /*yield*/, utils_1.utils.attemptAsync(function () {
                                return _this._httpClient.getOrdersAsync(__assign({}, requestOpts, { page: page }));
                            })];
                    case 2:
                        _a = _b.sent(), total = _a.total, records = _a.records, perPage = _a.perPage;
                        recordsToReturn = __spread(recordsToReturn, records);
                        page += 1;
                        lastPage = Math.ceil(total / perPage);
                        hasMorePages = page <= lastPage;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, recordsToReturn];
                }
            });
        });
    };
    return BaseSRAOrderProvider;
}(base_order_provider_1.BaseOrderProvider));
exports.BaseSRAOrderProvider = BaseSRAOrderProvider;
//# sourceMappingURL=base_sra_order_provider.js.map